import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Frame, Loading } from "@shopify/polaris";
import { useAppDispatch, useAppSelector } from "./hooks";
import { checkSession } from "containers/auth/authSlice";
import Orders from "containers/orders/orders";
import AppLayout from "pages/app/app-layout";
import LoginPage from "pages/auth/login/login";
import ProtectedRoute from "components/protectedRoute/ProtectedWrap";
import "./App.scss";

function App() {
  // const dispatch = useAppDispatch();
  // const { session, isCheckingSession, isError, isLoading, hasInitialSessionCheck } = useAppSelector((state) => state.authReducer);

  // // Check session ONLY on mount - never again
  // useEffect(() => {
  //   dispatch(checkSession());
  // }, []); // Empty dependency array = runs only once on mount

  // // Show loading while checking session OR if we haven't completed the initial session check
  // if (isCheckingSession || isLoading || !hasInitialSessionCheck) {
  //   return (
  //     <Frame>
  //       <Loading />
  //     </Frame>
  //   );
  // }

  return (
    <Frame>
      <Routes>
        <Route path="/" element={<Navigate to="/app" />} />
        {/* <Route path="auth/login" element={<LoginPage />} /> */}
        <Route path="app" element={<AppLayout />}>
          {/* <Route element={<ProtectedRoute />}> */}
            <Route index element={<Orders />} />
          {/* </Route> */}
        </Route>
      </Routes>
    </Frame>
  );
}

export default App;
